// extracted by mini-css-extract-plugin
module.exports = {"noContentMessage":"styles-module__noContentMessage___1hlFP"};